{
  "close": "Zatvori"
}
